import styled from 'styled-components'

export const Wrapper = styled.main`
  width: 100%;
  max-width: 380px;
  display: flex;
  align-items: center;
  flex-direction: column;

  input {
    width: 90%;
    height: 50px;
    background: #eaeaea;
    padding: 8px;
    margin: 8px;
    border-radius: 2px;
    border: none;
  }
`
